import { CircleAlert } from "lucide-react";
import React from "react";

const colorVariants = {
  amber: {
    wrapper:
      "bg-amber-50 dark:bg-amber-950/20 border-amber-400/30",
    icon:
      "text-amber-600 bg-amber-400/20",
    text:
      "text-amber-800 dark:text-amber-400",
  },
  red: {
    wrapper:
      "bg-red-50 dark:bg-red-950/20 border-red-400/30",
    icon:
      "text-red-600 bg-red-400/20",
    text:
      "text-red-800 dark:text-red-400",
  },
  green: {
    wrapper:
      "bg-green-50 dark:bg-green-950/20 border-green-400/30",
    icon:
      "text-green-600 bg-green-400/20",
    text:
      "text-green-800 dark:text-green-400",
  },
};
export default function MyCard5({ icon, title="", subtitle="", className="" ,color="amber"}) {
    
  const Icon = icon ?? CircleAlert;
  const varient= colorVariants[color]||colorVariants.amber;
  return (
    <div
      className={`${className} space-x-2   p-4 flex items-center justify-start border-1 rounded-lg ${varient.wrapper}`}
    >
      <Icon className={`w-8 h-8 p-1 rounded-md ${varient.icon}`} />
      <div className="flex flex-col justify-center">
        <span className={`text-sm font-semibold ${varient.text}`}>
          {title}
        </span>
        <span className={`text-[12px] font-normal ${varient.text} `}>
          {subtitle}
        </span>
      </div>
    </div>
  );
}
